"use client";

import React, { useEffect, useState } from "react";
import { X, Check } from "lucide-react";
import { createPortal } from "react-dom";

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
}

export default function SuccessModal({
  isOpen,
  onClose,
  title = "ĐĂNG KÝ THÀNH CÔNG",
  message = "Cảm ơn Quý khách đã quan tâm đến dự án Dragon Home. Thông tin của Quý khách đã được ghi nhận. Chuyên viên tư vấn của chúng tôi sẽ liên hệ trong thời gian sớm nhất.",
}: SuccessModalProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!mounted || !isOpen) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[2000] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-fade-in"
      onClick={onClose}
    >
      <div
        className="w-full max-w-[420px] bg-white rounded-2xl shadow-[0_20px_50px_-15px_rgba(0,0,0,0.3)] border border-gray-100 overflow-hidden relative transform transition-all duration-300 animate-scale-in"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Top Gold Border Decoration */}
        <div className="h-1.5 bg-gradient-to-r from-[#DFBA80] via-[#B59A7A] to-[#B39775]"></div>

        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition duration-200"
          aria-label="Close modal"
        >
          <X size={20} />
        </button>

        {/* Modal Content */}
        <div className="p-8 text-center flex flex-col items-center">
          {/* Animated pulsing success checkmark icon */}
          <div className="relative mb-6">
            <div className="absolute inset-0 rounded-full bg-[#B39775]/20 animate-ping opacity-75"></div>
            <div className="w-16 h-16 rounded-full bg-[#B39775] flex items-center justify-center shadow-lg relative z-10 border-4 border-white">
              <Check className="text-white w-8 h-8 stroke-[3]" />
            </div>
          </div>

          {/* Success Title */}
          <h3 className="text-lg md:text-xl font-black text-primary tracking-wider uppercase mb-3 font-montserrat">
            {title}
          </h3>

          <div className="w-10 h-0.5 bg-[#B59A7A] mb-4 rounded-full" />

          {/* Message Description */}
          <p className="text-gray-600 text-xs md:text-sm leading-relaxed font-semibold mb-6 max-w-[320px]">
            {message}
          </p>

          {/* Close CTA Button */}
          <button
            onClick={onClose}
            className="w-full bg-[#3E3227] hover:bg-[#6B5542] text-white py-3 rounded-xl font-bold uppercase tracking-wider text-xs md:text-sm shadow-md transition duration-300 transform active:scale-98"
          >
            ĐÓNG
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
